<template>
    <span>
        {{content.substring(0,truncate)}}
        <span v-if="content.length > truncate">...</span>
    </span>
</template>

<script>

export default {
  name: 'text-truncate',
  props: ['content', 'truncate']
}
</script>
